import {
  pList,
  rKiraBilgi,
  rValue,
  rYurtDisiTasinmazlariGenelBilgi,
} from '../../../../api/models/.catalog';
import { ActionSubTypes } from '../../../ActionSubTypes';
import Api from '../../../../api/ApiWrapper';
import { IApiAction, IPromiseAction } from '../../../../models/ActionModels';
import ActionFunctions from '../../../core/ActionFunctions';
import { IError } from '../../../../models/StateModels';
import { Collection } from '../../../../models/Collection';

export const action_async_start = (body: pList): IPromiseAction<pList> =>
  ActionFunctions.action_async_start_promise(
    ActionSubTypes.API_YURTDISITASINMAZGENELBILGI,
    new Api.Bilgi.YurtDisiTasinmazlariGenelBilgi().Request(body),
    false,
    false,
    body
  );

export const action_async_complete = (
  data: rValue<rYurtDisiTasinmazlariGenelBilgi> | null | undefined,
  error: IError | null | undefined
): IApiAction<rYurtDisiTasinmazlariGenelBilgi> =>
  ActionFunctions.action_async_complete_api<rYurtDisiTasinmazlariGenelBilgi>(
    ActionSubTypes.API_YURTDISITASINMAZGENELBILGI,
    { Data: new Collection(((data?.Value?.Data as unknown) as any) || []) },
    error
  );
